<template>
    <div class="page guide-detail">

        <guide-detail-skeleton v-if="loading" style="margin-bottom: 100vh"></guide-detail-skeleton>

        <div v-else>
            <div class="guide-detail-box">
                <h3 class="guide-detail-title">{{detail.title}}</h3>
                <div style="padding: 0 15px 15px">
                    <div class="guide-detail-time">{{detail.created_at}} {{detail.view_count}}人阅读</div>
                </div>
                <div class="clear" style="margin-top: 15px"></div>

                <div>
                    <div class="guide-detail-content">
                        <div class="rich_media_inner" v-html="detail.article.content"></div>
                    </div>
                </div>
            </div>

            <div class="guide-detail-footer">
                <div class="guide-detail-footer-box">
                    <div class="guide-detail-footer-right" style="width: 100%">
                        <van-grid direction="horizontal" :column-num="4" :border="false">
                            <van-grid-item @click="favorite()" v-if="detail.isFavorite" icon="/static/img/course/icon_course_favorite_on_20.svg" text="已收藏"/>
                            <van-grid-item @click="favorite()" v-else icon="/static/img/course/icon_course_favorite_off_20.svg" text="收藏"/>
                            <van-grid-item @click="pointLike()" v-if="detail.isLike" icon="/static/img/course/icon_course_like_on.svg" text="有帮助" :badge="detail.like_count"/>
                            <van-grid-item @click="pointLike()" v-else icon="/static/img/course/icon_course_like_off.svg" text="有帮助" :badge="detail.like_count"/>
                            <van-grid-item @click="goWechat()" icon="/static/bytx/tab_detail_feedback_icon.svg" text="反馈"/>
                            <van-grid-item @click="openShareData" icon="/static/img/course/icon_course_share_20.svg" text="转发"/>
                        </van-grid>
                    </div>
                </div>
                <van-number-keyboard safe-area-inset-bottom/>
            </div>

            <van-overlay :show="showShareDialog" @click="showShareDialog = false">
                <div class="share-box">
                    <div class="block">
                        请点击 “...”，再点击发送给朋友 | <span>知道啦</span>
                    </div>
                    <div class="share-box-bottom">
                        <img src="/static/bytx/detail_forward_2_img.png" alt="">
                    </div>
                </div>
            </van-overlay>

            <van-dialog class="feedback" v-model="openFeedback" :showConfirmButton="false">

                <template slot="title">
                    <div class="close-pop" @click="openFeedback = false">
                        <img src="/static/bytx/popup_close_icon.svg" alt="">
                    </div>
                    <h3>就诊指南反馈</h3>
                </template>

                <div class="clear"></div>

                <div>战友您好，请您长按识别下方二维码添加小助手，反馈您的意见与建议，博医同行将因您变得更好。</div>

                <div align="center">
                    <img src="/static/bytx/kefu.svg" alt="">
                </div>

            </van-dialog>

        </div>
    </div>

</template>

<script>
    import Interface from "@/util/interface"
    import guideDetailSkeleton from "@/skeleton/articleDetailSkeleton"
    import checkLogin from "../../../mixins/checkLogin";
    import {LocationHref} from '@/util/common'

    export default {
        name: 'guide-detail',
        mixins: [checkLogin],
        components: {
            'guide-detail-skeleton': guideDetailSkeleton
        },
        data() {
            return {
                id: 0,
                value: "",
                active: "",
                category_id: 0,
                category_child_id: 0,
                banners: [],
                categories: [],
                categories_child: [],
                recommend: [],
                list: [],
                column: [],
                guide: {},
                comment: [],
                comment_text: "",
                loading: true,
                share_data: {},
                showShareDialog: false,
                openFeedback:false,
                htmlUrl: "",
                isShow: false,
                status: "",
                comment_id: 0,
                to_user_id: 0,
                comment_placeholder: "写评论",
                user_id: 0,
                detail:{}
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'detail') {
                    Interface.getData('get', Interface.guide.detail + this.id).then((res) => {
                        this.detail = res.data
                        setTimeout(() => {
                            this.loading = false;
                        }, 500)
                        if (this.detail) {
                            Interface.getShareInfo(this, this.detail.title, this.detail.cover_img, this.detail.desc)
                        }
                        if(this.detail.article && this.detail.article.need_auth == 1){
                            this.addInfo('article')
                        }
                    })
                } else if (scene === 'footprint') {
                    let params = {
                        id: this.id,
                        type: 6,
                    }
                    Interface.getData('post', Interface.footprint, params).then((res) => {

                    })
                }
            },
            changeCategory() {
                this.fetch('guide')
            },
            favorite() {
                Interface.getData('get', Interface.guide.favorite + this.id).then((res) => {
                    if (res.code == 0) {
                        this.detail.isFavorite = !this.detail.isFavorite
                    }
                })
            },
            pointLike() {
                Interface.getData('get', Interface.guide.like + this.id).then((res) => {
                    if (res.code == 0) {
                        this.detail.like_count = this.detail.isLike ? parseInt(this.detail.like_count) - 1 : parseInt(this.detail.like_count) + 1
                        this.detail.isLike = !this.detail.isLike
                    }
                })
            },
            reComment(item) {
                this.comment_placeholder = '回复' + item.nickname
                this.comment_id = item.id
            },
            reCommentChild(item) {
                this.comment_placeholder = '回复' + item.nickname
                this.comment_id = item.comment_id
                this.to_user_id = item.user_id
            },
            pointLikeComment(item) {
                Interface.getData('get', Interface.pointLikeComment + item.id).then((res) => {
                    if (res.code == 0) {
                        item.isLike = !item.isLike
                        if (item.isLike) {
                            item.like_count += 1
                        } else {
                            item.like_count -= 1
                        }
                    }
                })

            },
            goComment() {
                this.$el.querySelector(".comment").scrollIntoView()
            },
            openShareData() {
                this.showShareDialog = true
            },
            goWechat(){
                LocationHref("https://work.weixin.qq.com/kfid/kfc80e2e65a20c7e4b8")
            }

        },
        created() {
            this.id = this.$route.params.id
            this.fetch('detail')
            this.fetch('footprint')
        },
    }
</script>

<style lang="scss">
    @import "./index";
    @import "../../../components/comment";
</style>



// WEBPACK FOOTER //
// src/views/guide/detail/index.vue